import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, Upload, Icon, notification, Row, Col, Typography, InputNumber, Carousel } from 'antd';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './DiningUpdate.css';

const { TextArea } = Input;
const { Text, Paragraph } = Typography;

@inject(
    'CmsLanguageStore',
    'CmsDiningStore'
)
@observer
class DiningUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    create = () => {
        this.props.CmsDiningStore.create().then(() => {
            this.props.CmsDiningStore.setupdateLoading(false);
            this.props.CmsDiningStore.setshowModal(false);
            this.props.CmsDiningStore.getAll();
        });
    }

    update = () => {
        this.props.CmsDiningStore.update().then(() => {
            this.props.CmsDiningStore.setupdateLoading(false);
            this.props.CmsDiningStore.setshowModal(false);
            this.props.CmsDiningStore.getAll();
        });
    }

    cancel = () => {
        this.props.CmsDiningStore.setshowModal(false);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsDiningStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsDiningStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'Dining'
                const titleName = title || 'Default'

                return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsDiningStore.setImageUrlById(id, response.imageUrl)
                    this.props.CmsDiningStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const {
            dining,
            updateLoading,
            images
        } = this.props.CmsDiningStore;

        let hasError = true;

        const defaultLang = dining.diningLanguages.find(fi => fi.languageId === 1);
        if (defaultLang) {
            hasError = images.length === 0 || defaultLang.title === '' || defaultLang.briefDescription === '' || defaultLang.description === '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                dining
                                    ?
                                    <>
                                        <Form layout='vertical'>

                                            {/* Title */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Title</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                dining.diningLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={2}
                                                                                                        value={dining.diningLanguages.find(fi => fi.languageId === lang.id).title}
                                                                                                        onChange={(e) => this.props.CmsDiningStore.settitle(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Brief Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Brief Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                dining.diningLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <TextArea
                                                                                                        rows={3}
                                                                                                        value={dining.diningLanguages.find(fi => fi.languageId === lang.id).briefDescription}
                                                                                                        onChange={(e) => this.props.CmsDiningStore.setbriefDescription(lang.id, e.target.value)}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Description */}
                                            <>
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                        <Row>
                                                            <Col span={24} className='stm-margin-bottom-16 stm-font-weight-bold'>Description</Col>
                                                            <>
                                                                {
                                                                    activeLanguages.map(lang => {
                                                                        return (
                                                                            <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                <Row>
                                                                                    <Col span={6}>{lang.originalName}</Col>
                                                                                    <Col span={18} className=''>
                                                                                        <>
                                                                                            {
                                                                                                dining.diningLanguages.find(fi => fi.languageId === lang.id)
                                                                                                    ?
                                                                                                    <CKEditor
                                                                                                        editor={ClassicEditor}
                                                                                                        data={dining.diningLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                        onChange={(event, editor) => {
                                                                                                            const data = editor.getData();
                                                                                                            this.props.CmsDiningStore.setdescription(lang.id, data)
                                                                                                        }}
                                                                                                    />
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                        </>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Sort */}
                                            <>
                                                <Form.Item label='Sort'>
                                                    <InputNumber
                                                        className='stm-width-100'
                                                        value={dining.sort}
                                                        onChange={(value) => this.props.CmsDiningStore.setsort(value)}
                                                        min={1}
                                                    />
                                                </Form.Item>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    images.map(image => {
                                                        return (
                                                            <Form.Item key={image.id} label={
                                                                image.url === ''
                                                                    ?
                                                                    'Create Banner (Minimum resolution: 640x480)'
                                                                    :
                                                                    <>
                                                                        <Row className='updatedining-row-label'>
                                                                            <Col span={12} className='updatedining-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                            <Col span={12} className='updatedining-col-label-button'>
                                                                                <Button type='danger' onClick={() => this.props.CmsDiningStore.removeImageById(image.id)}>Delete</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }>
                                                                <Upload
                                                                    listType='picture-card'
                                                                    className='avatar-uploader'
                                                                    showUploadList={false}
                                                                    customRequest={this.dummyRequest}
                                                                    beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                                    onChange={(info) => this.uploadChange(info, image.id, 'Dining')}
                                                                >
                                                                    {
                                                                        image.url !== ''
                                                                            ?
                                                                            <img src={image.url} alt='avatar' className='updatedining-img' />
                                                                            :
                                                                            <div>
                                                                                <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                <div className='ant-upload-text'>Upload</div>
                                                                            </div>}
                                                                </Upload>
                                                            </Form.Item>
                                                        )
                                                    })
                                                }
                                            </>

                                            {/* Preview */}
                                            <>
                                                <Form.Item label='Preview Banner'>
                                                    <Row>
                                                        <Col span={24} className='updatedining-col-preview-container'>
                                                            {
                                                                images.length === 1
                                                                    ?
                                                                    null
                                                                    :
                                                                    <Row>
                                                                        <Col className='updatedining-col-preview-img'>
                                                                            <Row>
                                                                                <Col
                                                                                    span={24}
                                                                                    className={images.length === 2 ? 'updatedining-col-carousel-container-single' : 'updatedining-col-carousel-container'}
                                                                                >
                                                                                    <Carousel>
                                                                                        {
                                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                                return (
                                                                                                    <div key={image.id} className='updatedining-div-carousel'>
                                                                                                        <Row className='updatedining-row-carousel'>
                                                                                                            <Col span={24} className='updatedining-col-carousel'>
                                                                                                                <img className='updatedining-img-carousel' src={image.url} alt={image.id} />
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Carousel>
                                                                                </Col>
                                                                            </Row>
                                                                            <>
                                                                                {
                                                                                    dining.diningLanguages.find(fi => fi.languageId === 1)
                                                                                        ?
                                                                                        <>
                                                                                            <Row className='updatedining-row-detail'>
                                                                                                <Col span={24} className='updatedining-col-preview-title'>
                                                                                                    <Text className='updatedining-text-preview-title'>{dining.diningLanguages.find(fi => fi.languageId === 1).title}</Text>
                                                                                                </Col>
                                                                                                <Paragraph className='clr-theme-dark-1'>
                                                                                                    <Markup content={dining.diningLanguages.find(fi => fi.languageId === 1).description} />
                                                                                                </Paragraph>
                                                                                            </Row>
                                                                                        </>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </>

                                                                        </Col>
                                                                    </Row>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </>

                                            {/* Button */}
                                            <>
                                                <Form.Item>
                                                    {
                                                        dining.id === 0
                                                            ?
                                                            <Button onClick={this.create} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                            :
                                                            <Button onClick={this.update} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>
                                                    }

                                                    <Button onClick={this.cancel}>Cancel</Button>
                                                </Form.Item>
                                            </>
                                        </Form>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default DiningUpdate;